import { Component, OnInit } from "@angular/core";
import { AlertsService } from "./alerts.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { Alert, AlertInstance } from "./alerts.model";
import { AlertsMap, AlertType, Constants } from "../../shared/constants";
import { DevicesService } from "../devices/devices.service";
import { MatDialog, MatDialogRef } from "@angular/material";
import { AlertsCreateDialogComponent } from "./alerts-create-dialog/alerts-create-dialog.component";

@Component({
  selector: "app-alerts",
  templateUrl: "./alerts.component.html",
  styleUrls: ["./alerts.component.scss"],
})
export class AlertsComponent implements OnInit {
  loading = true;
  alerts: any;
  associatedDevices = [];
  dialogRef: MatDialogRef<AlertsCreateDialogComponent>;

  constructor(
    private alertsService: AlertsService,
    private sessionStateService: SessionStateService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getAlerts();
  }

  getAlerts() {
    this.alertsService.getHouseAlerts().subscribe((alerts) => {
      this.alerts = alerts["houseAlerts"];
      this.loading = false;
    });
  }

  isSupported(tag: string) {
    return this.alerts["supported"].includes(tag);
  }

  getAlertIcon(alertType: AlertType): string {
    return `./assets/img/icons/${AlertsMap.map.get(alertType).icon}`;
  }

  getAlertName(alertType: AlertType): string {
    return AlertsMap.map.get(alertType).name;
  }

  getAlert(type) {
    return this.alerts[type].alerts;
  }

  getAssociatedDevices(type) {
    return this.getAlert(type).length;
  }

  openDialog(name: string, type: string, flipStatus?) {
    this.dialogRef = this.dialog.open(AlertsCreateDialogComponent, {
      data: {
        alert: this.getAlert(type),
        name: name,
        type: type,
        status: flipStatus
          ? !this.alerts[type]["alertStatus"]
          : this.alerts[type]["alertStatus"],
        value:
          type === "budgetControl" && this.alerts["budgetControl"]["alerts"][0]
            ? this.alerts["budgetControl"]["alerts"][0]["alertParameters"][
                "conditions"
              ]["monthlyConsumptionPrediction"]
            : 0,
      },
      autoFocus: false,
      panelClass: "inputPopup",
    });

    this.dialogRef.componentInstance.action.subscribe((update) => {
      if (update) {
        this.getAlerts();
      }
    });
  }

  changeAlertState(type, state: boolean) {
    if (type === "budgetControl") {
      if (this.alerts["budgetControl"]["alerts"][0]) {
        const value = this.alerts["budgetControl"]["alerts"][0][
          "alertParameters"
        ]["conditions"]["monthlyConsumptionPrediction"];
        if (!state) {
          this.alertsService
            .updateBudgetControl(!state, value)
            .subscribe((res) => {
              this.getAlerts();
              this.openDialog("Budget Control", "budgetControl", true);
            });
        } else {
          this.alertsService
            .updateBudgetControl(!state, value)
            .subscribe((res) => {
              this.getAlerts();
            });
        }
      } else {
        this.openDialog("Budget Control", "budgetControl", true);
      }
    } else if (type === "deviceDisconnection") {
      if (!state) {
        this.alertsService.changeDeviceDisconnection(state).subscribe((res) => {
          this.getAlerts();
        });
      } else {
        this.alertsService
          .deleteDeviceDisconnection(
            this.alerts["deviceDisconnection"]["alerts"][0]["alertId"]
          )
          .subscribe((res) => {
            this.getAlerts();
          });
      }
    } else if (type === "noProduction") {
      if (!state) {
        this.alertsService.changeNoProduction(state).subscribe((res) => {
          this.getAlerts();
        });
      } else {
        this.alertsService
          .deleteNoProduction(
            this.alerts["noProduction"]["alerts"][0]["alertId"]
          )
          .subscribe((res) => {
            this.getAlerts();
          });
      }
    } else if (type === "unusualWeekHourConsumption") {
      if (!state) {
        this.alertsService
          .changeUnusualWeekHourConsumption(state)
          .subscribe((res) => {
            this.getAlerts();
          });
      } else {
        this.alertsService
          .deleteUnusualWeekHourConsumption(
            this.alerts["unusualWeekHourConsumption"]["alerts"][0]["alertId"]
          )
          .subscribe((res) => {
            this.getAlerts();
          });
      }
    } else if (type === "noProduction") {
      if (!state) {
        this.alertsService.changeNoProduction(state).subscribe((res) => {
          this.getAlerts();
        });
      } else {
        this.alertsService
          .deleteNoProduction(
            this.alerts["noProduction"]["alerts"][0]["alertId"]
          )
          .subscribe((res) => {
            this.getAlerts();
          });
      }
    } else if (type === "equipmentLeftOnTooLong") {
      if (!state) {
        this.alertsService
          .changeEquipmentLeftOnTooLong(state)
          .subscribe((res) => {
            this.getAlerts();
          });
      } else {
        this.alertsService
          .deleteEquipmentLeftOnTooLong(
            this.alerts["equipmentLeftOnTooLong"]["alerts"][0]["alertId"]
          )
          .subscribe((res) => {
            this.getAlerts();
          });
      }
    }
  }

  devicesAlertsCount() {
    let count = 0;
    if (this.isSupported("noConsumptionByFridge")) {
      count++;
    }
    if (this.isSupported("consumptionOutsideEconomicPeriod")) {
      count++;
    }
    if (this.isSupported("significantConsumptionIncrease")) {
      count++;
    }
    return count;
  }

  houseAlertsCount() {
    let count = 0;
    if (this.isSupported("deviceDisconnection")) {
      count++;
    }
    if (this.isSupported("budgetControl")) {
      count++;
    }
    if (this.isSupported("noProduction")) {
      count++;
    }
    if (this.isSupported("unusualWeekHourConsumption")) {
      count++;
    }
    if (this.isSupported("equipmentLeftOnTooLong")) {
      count++;
    }
    return count;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/alerts/alerts.component.ts